module.exports = __webpack_public_path__ + "img/banner-bonus-class-offer-50-off-next-level.2b5e1a89.png";